import { render, staticRenderFns } from "./SectionManager.vue?vue&type=template&id=2e7468e3&"
import script from "./SectionManager.vue?vue&type=script&lang=ts&"
export * from "./SectionManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports